import script from "./ProjectDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDashboard.vue?vue&type=style&index=0&id=394099b8&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394099b8"]])

export default __exports__